import React, { useState } from "react";
import { FormSectionElements, FormSections, ProgramContainer } from "src/entities/formTemplateDataType";
import { ReactComponent as CloseIcon } from '../../../../public/assets/css/ontario-design-system/icons/ontario-icon-close.svg';
import { Checkbox } from "primereact/checkbox";

interface Props {
    token?: string;
    programContainer: ProgramContainer;
    isEng: boolean;
    field: FormSectionElements;
    onButtonClick?: (data) => void;
    callback?: (p: ProgramContainer) => void;
    onRequestClose?: () => void;
}

const EhocmAdminApprovalDeny: React.FC<Props> = ({programContainer, isEng, field, onButtonClick, onRequestClose, callback}) => {
    const [confirm1, setConfirm1] = useState(false)
    const [denyReason, setDenyReason] = useState('')

    const fields = field.parent?.ListOfFormSectionElements;
    const statusField = fields?.find(ele => ele.LoadBindName === 'statusSummary')
    const firstNameField = fields.find(ele => ele.LoadBindName === 'firstNameSummary')
    const lastNameField = fields.find(ele => ele.LoadBindName === 'lastNameSummary')
    const emailField = fields.find(ele => ele.LoadBindName === 'emailSummary')
    const orgField = fields.find(ele => ele.LoadBindName === 'organizationNameSummary')
    const status = field.Value

    return (
        <div style={{margin: '1rem'}}>
            <div>
                <div style={{display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between'}}>
                    <h3>{isEng ? `Confirm ${status === 'Approve' ? 'approval' : 'denial'}` : `Confirmer ${status === 'Approve' ? "l'approbation" : 'le refus'}`}</h3>
                    <a style={{ color: 'inherit' }} href='#' onClick={(e) => { e.preventDefault(); onRequestClose()}}>
                        <CloseIcon />
                    </a>
                </div>

                <p>{isEng ? (status === 'Approve' ? 'Are you sure you want to approve this request?' : 'Are you sure you want to deny this request?') : (status === 'Approve' ? 'Êtes-vous sûr de vouloir approuver cette demande?' : 'Êtes-vous sûr de vouloir refuser cette demande?')}</p>
                <div style={{display: 'flex', flexWrap: 'wrap', placeContent: 'start', gap: '2rem', marginBottom: '1rem'}}>
                    <div style={{display: 'flex', flexWrap: 'nowrap', gap: '2rem', justifyContent: 'space-between', paddingRight: '1rem'}}>
                        <span><b>Requested by: </b>{firstNameField?.Value} {lastNameField?.Value}</span>
                        {firstNameField?.Value && lastNameField.Value && <span>|</span>}
                    </div>
                    {emailField?.Value && (
                        <div style={{display: 'flex', flexWrap: 'nowrap', justifyContent: 'space-between', paddingRight: '1.5rem'}}>
                            <span>{emailField.Value}</span>
                            <span>|</span>
                        </div>
                    )}
                    {orgField.Value && (<span>{orgField.Value}</span>)}
                </div>

                {status === 'Approve' && (
                <div style={{display: 'flex', flexWrap: 'nowrap', justifyContent: 'flex-start', gap: '1.5 rem'}}>
                    <Checkbox checked={confirm1} onChange={() => setConfirm1(!confirm1)} inputId={'admin-approval-deny-confirm1'}/>
                    <label htmlFor="admin-approval-deny-confirm1" style={{paddingLeft: '1.5rem'}}>
                        {isEng? 'I certify that I have reviewed all supporting documentation submitted with this application, met with the applicant to verify their identity to the documentation provided and, to the best of my knowledge, the applicant is qualified to serve as an Organization Administrator for the organization referenced herein.' : "Je certifie avoir examiné tous les documents justificatifs soumis avec cette demande, avoir rencontré le demandeur pour vérifier son identité par rapport aux documents fournis et, à ma connaissance, le demandeur est qualifié pour servir d'administrateur d'organisation pour l'organisation mentionnée dans les présentes."}
                    </label>
                </div>
                )}

                {status === 'Deny' && (
                <div style={{marginBottom: '1rem'}}>
                    <label htmlFor="admin-deny-reason" style={{fontWeight: 'bold', display: 'block', marginBottom: '0.5rem'}}>
                        {isEng ? 'Denial reasons' : 'Raisons du refus'} <span style={{fontWeight: 'normal'}}>({isEng ? 'required' : 'obligatoire'})</span>
                    </label>
                    <textarea
                        id="admin-deny-reason"
                        value={denyReason}
                        onChange={(e) => setDenyReason(e.target.value)}
                        rows={5}
                        style={{width: '100%', resize: 'vertical'}}
                    />
                </div>
                )}

                <div style={{marginTop: '1rem'}}>
                    <button
                        className={`ontario-button ontario-button--primary`}
                        disabled={status === 'Approve' ? !confirm1 : !denyReason.trim()}
                        onClick={() => onButtonClick({status, ...(status === 'Deny' && {denyReason})})}>
                        {isEng ? (status === 'Approve' ? 'Confirm approval' : 'Confirm denial') : (status === 'Approve' ? "Confirmer l'approbation" : 'Confirmer le refus')}
                    </button>
                    <button className="ontario-button ontario-button--secondary" onClick={onRequestClose}>
                        {isEng ? 'Cancel' : 'Annuler'}
                    </button>
                </div>
            </div>
        </div>
    )
}

export default EhocmAdminApprovalDeny;